
/* eslint-disable */

const BASE_HOST = (process.env.REACT_APP_BASE_HOST || "").toLowerCase().trim();

const BASE_DOMAIN = (process.env.REACT_APP_BASE_DOMAIN || "myacademic.org")
    .toLowerCase()
    .replace(/^\./, "");

const RESERVED_SUBDOMAINS = new Set([
    "www", "api", "admin", "career", "turing",
    "static", "cdn", "localhost", "app", "mail",
]);

const EMPTY_TENANT = { isTenant: false, tenantSlug: null };

/**
 * Extracts a tenant slug from a hostname and its base domain.
 */
function extractTenant(hostname, domain) {
    if (!hostname.endsWith(`.${domain}`)) return null;

    const slug = hostname.slice(0, -(domain.length + 1));

    if (!slug || slug.includes(".") || RESERVED_SUBDOMAINS.has(slug)) {
        return null;
    }

    return slug;
}

/**
 * Determines whether the current URL belongs to an organisation tenant.
 */
export function getTenantFromUrl() {
    const hostname = window.location.hostname.toLowerCase();

    if (!hostname) return EMPTY_TENANT;

    if (hostname === BASE_HOST || hostname === `www.${BASE_HOST}`) {
        return EMPTY_TENANT;
    }

    const slug = extractTenant(hostname, BASE_HOST);

    return slug
        ? { isTenant: true, tenantSlug: slug }
        : EMPTY_TENANT;

}

/**
 * Returns the canonical central platform URL without tenant subdomains.
 */
export function getCentralPlatformUrl() {
    if (typeof window === "undefined") return "/";

    const { protocol, port, hostname } = window.location;
    const portSuffix = port ? `:${port}` : "";

    return `${protocol}//${BASE_HOST}${portSuffix}`;
}
